import clampMonths from '~addListing/pages/PriceStep/utils/clampMonths';
import clampYears from '~addListing/pages/PriceStep/utils/clampYears';
import roundToHalf from '~addListing/pages/PriceStep/utils/roundToHalf';
import roundToMonth from '~addListing/pages/PriceStep/utils/roundToMonth';
import {
  DAYS_IN_YEAR,
  NUMBER_DAYS_IN_MONTH,
} from '~addListing/pages/PriceStep/utils/constants';

// Converts a selected installment period (in years or months) to its duration in days.
const getDurationInDays = (
  value: number,
  installmentPeriodType: 'years' | 'months',
) =>
  installmentPeriodType === 'months'
    ? clampMonths(roundToMonth(value)) * NUMBER_DAYS_IN_MONTH
    : clampYears(roundToHalf(value)) * DAYS_IN_YEAR;

export default getDurationInDays;
